// Analytics provider component that initializes analytics from backend settings
import { useEffect } from 'react';
import { analytics } from '../../utils/analytics';
import type { AnalyticsConfig } from '../../utils/analytics';
import { unifiedApiService } from '../../services/unified';

interface AnalyticsProviderProps {
  children: React.ReactNode;
}

export function AnalyticsProvider({ children }: AnalyticsProviderProps) {
  useEffect(() => {
    const initializeAnalytics = async () => {
      try {
        // Fetch analytics settings from backend
        const settings = await unifiedApiService.system.getPublicSettings();

        // Extract analytics configuration
        const config: AnalyticsConfig = {
          enabled: (settings as any).analytics_enabled?.value === 'true',
          googleAnalyticsId: (settings as any).analytics_google_analytics_id?.value,
          googleTagManagerId: (settings as any).analytics_google_tag_manager_id?.value,
          cookieConsentRequired: (settings as any).analytics_cookie_consent_required?.value === 'true',
        };

        // Initialize analytics with configuration
        await analytics.initialize(config);

        console.log('[AnalyticsProvider] Analytics initialized:', config);
      } catch (error) {
        console.error('[AnalyticsProvider] Failed to initialize analytics:', error);
        // Continue without analytics
      }
    };

    initializeAnalytics();
  }, []);

  // Don't block rendering while initializing
  return <>{children}</>;
}
